import { Injectable } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';

import { HttpClient } from '@angular/common/http';

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  if (!fjs) return; // Skip if no script tags found (e.g., in test environment)
  js = d.createElement(s);
  js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  //@ts-ignore: Facebook SDK
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  constructor(private http: HttpClient) {}

  login(appId: string): Promise<object> {
    return new Promise((resolve, reject) => {
      //@ts-ignore: FB login
      FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: 'v6.0',
      });

      //@ts-ignore: FB login
      FB.login(response => {
        if (response.status === 'connected') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  }

  // https://developers.facebook.com/docs/pages/access-tokens/
  async getPageAccessToken(response: object, appId: string, appSecret: string, pageId: string): Promise<object> {
    const accessToken = response['authResponse']['accessToken'];
    const userId = response['authResponse']['userID'];

    const longLivedUserAccessTokenUrl = `https://graph.facebook.com/oauth/access_token?
grant_type=fb_exchange_token&client_id=${appId}&
client_secret=${appSecret}&fb_exchange_token=${accessToken}`;

    const tokenResponse = await firstValueFrom(this.http.get<object>(longLivedUserAccessTokenUrl).pipe(take(1)));

    const longAccessToken = tokenResponse['access_token'];

    const pageAccessTokenUrl = `https://graph.facebook.com/${pageId}?
fields=access_token&access_token=${longAccessToken}`;

    return firstValueFrom(this.http.get<object>(pageAccessTokenUrl).pipe(take(1)));
  }
}
